<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script setup >
// props="['width','height','right1Data']"
name: "baseBar";
import { ref, onMounted,defineProps } from "vue";
import * as echarts from "echarts";
const props =defineProps({
  width: {
    type: String,
    default: "100%",
  },
  height: {
    type: String,
    default: "100%",
  },
  listData: {
    type: Object,
    default: () => {},
  },
})
// console.log(props.listData);
const myEcharts = ref(null);

onMounted(() => {
  // let data = [
  //   { value: 287.5, name: "2023年全县生产总值" },
  //   { value: 54.57, name: "第一产业增加值" },
  //   { value: 93.51, name: "第二产业增加值" },
  //   { value: 139.44, name: "第三产业增加值" },
  // ];
  initChart(props.listData);
});

function initChart(listData) {
  if (myEcharts.value && myEcharts.value.chart) {
    myEcharts.value.chart.dispose();
  }
  const chartInstance = echarts.init(myEcharts.value);

  var colorList = ['#FFD076', '#45F4F5'];
// 颜色值配置一个空，用于显示间距
  const colorList1 = ['#ffd076', '', '#45F4F5', ''];
  const colorList2 = ['rgba(255, 208, 118, 0.4)', '', 'rgba(69, 244, 245, 0.4)', '']
  var data = [
    {
      "name": "一期项目",
      "value": "4837",
      "percent": "21.59"
    },
    {
      "name": "二期项目",
      "value": "17563",
      "percent": "78.41"
    },


  ];
  let sum = 0;
  let optionData = []
  data.forEach(item => {
    sum += Number(item.value);
  })
  data.forEach(item => {
    optionData.push({ value: item.value, name: item.name });
    // 配置一个空值
    optionData.push({ name: '', value: sum / 100, itemStyle: { color: 'transparent' } });
  })
  const option= {

    tooltip: {
      trigger: 'item',
    },
    title: {
      text: "100%",
      left: '24%',
      top: '45%',
      itemGap: 10,
      textStyle: {
        color: '#fff',
        fontSize: 20,
        fontWeight: 500
      },
      textAlign: 'center',
      subtext: '',
      subtextStyle: {
        color: 'rgba(255,255,255,0.5)',
        fontSize: 20,
        fontWeight: 600
      }
    },

    legend: {
      icon: 'none',
      orient: "vertical",
      top: "20%",
      left:"45%",

      itemWidth: 5,
      itemHeight: 65,
// itemStyle: {
//     color: '#00f'
// },
      formatter: (name) => {
        let obj = data.find(item => item.name === name)
        const arr = [
          `{iconName|}{name|${name}\n\n}{percent|${obj.percent}}{unit|%}{value|${obj.value}万元}`
        ];
        return arr.join('')
      },
      textStyle: {
        color: '#FFF',
        fontSize: 14,
        rich: {
          name: {
            color: '#FFF',
            fontSize: 14,
            width: 100,
            padding: [0, 0, 0, 10],
          },
          value: {
            color: '#FFE400',
            fontFamily: 'PangMenZhengDao',
            fontSize: 14,
            width: 40,
            textAlign: 'right',
            padding: [0, 0, 0, 10]
          },
          percent: {
            color: '#FFD076',
            fontFamily: 'PangMenZhengDao',
            fontSize: 14,
            padding: [0, 0, 0, 30]
          },
          unit: {
            color: '#ACDCE4',
            fontSize: 18,
            padding: [0, 0, 0, 5]
          },


        }
      },
      data: data.map((dItem,dIndex) => {
        return {
          ...dItem,
          textStyle: {
            rich: {
              iconName: {
                width: 16,
                height: 16,
                borderRadius: 50,
                backgroundColor: colorList[dIndex],
              },
              percent: {
                color: colorList[dIndex],
              },
            }
          },

        }
      }),
    },

    series: [

      {
        // 饼图圈
        type: 'pie',
        zlevel: 3,
        radius: ['40%', '45%'],
        center: ['25%', '50%'],
        itemStyle: {
          normal: {
            //  borderColor: '#0A1934',
            // borderWidth:5,
            color: function (params) {
              return colorList2[params.dataIndex]
            }
          }
        },
        label: {
          show: false,
        },
        data: optionData,
      },
      {
        // 最外圆圈
        type: 'pie',
        zlevel: 1,
        silent: true, //取消高亮
        radius: ['55%', '65%'],
        center: ['25%', '50%'],
        itemStyle: {
          normal: {
            //  borderColor: '#0A1934',
            // borderWidth:5,
            color: function (params) {
              return colorList1[params.dataIndex]
            }
          }
        },
        label: {
          show: false
        },
        data: optionData,
      },
      {
        type: "pie",
        radius: ['44%', '44.2%'],
        center: ['25%', '50%'],
        // radius: '90%',
        hoverAnimation: false,
        clockWise: false,

        itemStyle: {
          normal: {
            shadowBlur: 1,
            shadowColor: "rgba(15, 79, 150,0.61)",
            color: "rgba(23,138,173,1)",
          },
        },
        label: {
          show: false,
        },
        data: [0],
      },
      {
        type: "pie",
        radius: ['44%', '44.6%'],
        center: ['25%', '50%'],
        // radius: '90%',
        hoverAnimation: false,
        clockWise: false,
        color: [
          "#55c2e200",
          "rgba(23,138,173,1)",
          "#ff5a6100",
          "ff5a6100",
        ],
        label: {
          show: false,
        },
        data: [140, 60, 240, 130],
        // data: [30,30,30,30,30,30],
      },
    ]
  };// 将你的ECharts配置项放在这里
  chartInstance.setOption(option, true);
}
window.addEventListener("resize", () => {
  chartInstance.resize();
});

</script>
<style lang="less"></style>
